export const GET_PROJECTS = "GET_PROJECTS";
export const FILTER_PROJECTS = "FILTER_PROJECTS";
export const ADD_PROJECT = "ADD_PROJECT";
export const EDIT_PROJECT = "EDIT_PROJECT";
export const GET_PROJECT = "GET_PROJECT";
export const RESET_PROJECT = "RESET_PROJECT";
export const PROJECTS_ERROR = "PROJECTS_ERROR";
